module.exports = __webpack_public_path__ + "static/media/logo-tagged.e3458d41.svg";